import { render, staticRenderFns } from "./CompanyNoInfo.vue?vue&type=template&id=e4b2ed70&scoped=true"
var script = {}
import style0 from "./CompanyNoInfo.vue?vue&type=style&index=0&id=e4b2ed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b2ed70",
  null
  
)

export default component.exports